import { render, staticRenderFns } from "./settingEngagements.vue?vue&type=template&id=10cbbc46&scoped=true&"
import script from "./settingEngagements.vue?vue&type=script&lang=js&"
export * from "./settingEngagements.vue?vue&type=script&lang=js&"
import style0 from "./settingEngagements.vue?vue&type=style&index=0&id=10cbbc46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cbbc46",
  null
  
)

export default component.exports